/* =====================================================================
 * specializedAgentPanelSlot — DI slot for embedded specialized-agent panels.
 *
 * 매니페스트의 `specializedAgents[].id` 마다 별도 패널 컴포넌트가 존재한다
 * (예: `cad` → `CADAgentPage`). StoragePage 의 좌측에서 사용자가 specialized
 * 에이전트 노드를 클릭하면, StoragePage 메인 영역에 해당 패널을 그대로
 * 임베드해 동일한 트리/파일 영역을 보여준다.
 *
 * shared 패키지(`@auw/workspace-ui`)는 호스트 전용 컴포넌트를 직접 import
 * 할 수 없으므로 DI 로 처리한다. 호스트(`askyourai/main.tsx`) 가 bootstrap
 * 시점에 `setSpecializedAgentPanelComponent('cad', CADAgentPage)` 로 등록.
 * 매핑이 없는 id 는 StoragePage 에서 "준비 중" 안내로 fallback.
 * ===================================================================== */

import type React from 'react';

export type SpecializedAgentPanelComponent = React.ComponentType<Record<string, never>>;

const _registry = new Map<string, SpecializedAgentPanelComponent>();

export function setSpecializedAgentPanelComponent(
  id: string,
  comp: SpecializedAgentPanelComponent | null,
): void {
  if (comp) _registry.set(id, comp);
  else _registry.delete(id);
}

export function getSpecializedAgentPanelComponent(
  id: string,
): SpecializedAgentPanelComponent | null {
  return _registry.get(id) ?? null;
}
